export default {
  env: state => {
    return state.env;
  }
};
